import React from 'react';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import {Icon} from 'epic-diesel-common';
import {FormsyProps} from '../external/types';

//@ts-ignore
import styles from './Radiobox.pcss';

interface Props extends FormsyProps {
    name: string;
    className?: string;
    onChange?: (name: string, value: boolean) => void;
    disabled?: boolean;
}

const RadioBox: React.FC<Props> = props => {
    const {
        name,
        children,
        className,
        getValue,
        isPristine,
        showError,
        getErrorMessage,
        disabled
    } = props;

    const onClick = event => {
        if (props.onChange && !props.disabled) {
            const value = !props.getValue();
            props.onChange(props.name, value);
        }
    };

    const isError = !isPristine() && showError();
    const wrapperClasses = cx(styles.wrapper, className, {
        [styles.disabled]: disabled
    });
    const isChecked = !!getValue(); // assuming this is a boolean

    return (
        <div className={wrapperClasses} data-name={name} role="presentation" onClick={onClick}>
            <div className={styles.checkboxContainer}>
                <Icon
                    className={styles.icon}
                    icon={isChecked ? 'CIRCLE' : 'CIRCLE_EMPTY'}
                    fontSize="small"
                />
                <div className={styles.text}>{children}</div>
            </div>
            {isError && <div className={styles.error}>{getErrorMessage()}</div>}
        </div>
    );
};

export default withFormsy(RadioBox);
